<ng-container [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Request New Document</h5>
  </div>
  <div class="modal-body" ngbAutofocus>
    <div class="form-row" *ngIf="props.docType === 'OTHER'">
      <div class="form-group col-7">
        <app-dc-select
          formControlName="type"
          [labelId]="'type'"
          label="Document Type"
          [items]="docTypes"
          closeOnSelect="true"
        >
        </app-dc-select>
      </div>
    </div>
    <ng-container *ngIf="!isTMG">
      <div class="form-row">
        <div class="form-group col-7 language">
          <app-dc-select
            formControlName="language"
            [labelId]="'language'"
            label="Select language*"
            [items]="languages"
            closeOnSelect="true"
          >
          </app-dc-select>
        </div>
      </div>
      <div class="form-group col-7 documentState">
        <app-dc-select
          formControlName="documentState"
          [labelId]="'documentState'"
          label="Select document type"
          [items]="documentStateItems"
          closeOnSelect="true"
        >
        </app-dc-select>
      </div>
      <div class="form-row">
        <div class="form-group col-7 docFormat">
          <app-dc-select
            formControlName="docFormat"
            [labelId]="'docFormat'"
            label="Select document format"
            [items]="documentFormat"
            closeOnSelect="true"
          >
          </app-dc-select>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="form.invalid"
      (click)="save()"
    >
      Request
    </button>
  </div>
</ng-container>
